<template>
  <b-row align-v="center" class="mt-2">
    <b-col cols="3" class="text-right">
      <small class="font-italic titles">
        {{ label }}
      </small>
    </b-col>
    <b-col>
      <b-progress :value="progress" />
    </b-col>
    <b-col cols="2" class="text-center progress-number">
      <small>{{ progress.toFixed() }}%</small>
    </b-col>
  </b-row>
</template>

<script>
  export default {
    name: 'ProgressLabelComponent',
    props: {
      label: {
        type: String,
        default: null,
      },
      progress: {
        type: Number,
        default: 0,
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';

  .titles {
    color: $grey;
  }

  .progress-number {
    color: lighten($primary, 10);
  }

  /deep/.progress {
    border-radius: 10px;
    height: 10px !important;

    .progress-bar {
      border-radius: 10px;
    }
  }
</style>
